import { useParams } from "react-router-dom";
import ProfileForm from "../../components/Profile/ProfileForm";
import RepresentantForm from "../../components/Profile/RepresentantForm";
import { useModal } from "../../hooks/use-modal.jsx";
import { Profile } from "../../models/profile";
import { useTenantProfiles } from "../../hooks/use-profiles-indiv";

export default function EditPage() {
  const { tenantId, profileId } = useParams();
  const [Modal, closeModal] = useModal(true);
  const { profiles, updateProfile } = useTenantProfiles(tenantId);

  const profile = profiles.find(
    (profile) => profile.id === parseInt(profileId),
  );

  if (!profile) return null;

  const submitHandler = async (data) => {
    await updateProfile(parseInt(profileId), Profile.create(data));
    closeModal();
  };

  if (profile.legal_representative_of != null) {
    return (
      <RepresentantForm
        profile={profile}
        onSubmit={submitHandler}
        modal={Modal}
      />
    );
  }

  return (
    <ProfileForm
      profile={profile}
      onSubmit={submitHandler}
      modal={Modal}
      withOldAddressField={profile.garantor_of === null}
    />
  );
}
